import {forwardRef, useState} from "react";
import {FiEye, FiEyeOff} from "react-icons/fi";

import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {Input} from "@/components/input/Input.tsx";
import {InputProps} from "@/components/input/Input.types.ts";
import {InputGroup} from "@/components/inputGroup/InputGroup.tsx";

interface PasswordInputProps extends InputProps {
  hideMaskButton?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({hideMaskButton, disabled, ...rest}, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <InputGroup
        endElement={
          !hideMaskButton && (
            <IconButton
              icon={visible ? FiEyeOff : FiEye}
              variant="ghost"
              size="fitIcon"
              onClick={() => setVisible(!visible)}
            />
          )
        }
        disabled={disabled}
        endElementProps={{disablePointerEvents: false}}
      >
        <Input ref={ref} type={visible ? "text" : "password"} {...rest} />
      </InputGroup>
    );
  }
);
